var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2314 36.0217H2.23145C1.12689 36.0217 0.231445 35.1263 0.231445 34.0217V0.0217285H4.23145V32.0217H36.2314V36.0217ZM10.9774 26.0217L8.23145 23.3337L17.9434 13.8217C18.708 13.0787 19.9248 13.0787 20.6894 13.8217L25.1434 18.1837L33.4854 10.0217L36.2314 12.7097L26.5194 22.2217C25.7548 22.9647 24.538 22.9647 23.7734 22.2217L19.3174 17.8577L10.9774 26.0217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartUp);
export default __webpack_public_path__ + "static/media/chartUp.4efe7751f78c42edcb2ec71d0882156b.svg";
export { ForwardRef as ReactComponent };